import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';

export interface AccountChangeContext {
  neonUserId: string;
}

const context = createContext<AccountChangeContext>({
  neonUserId: ''
});

export const useNeonUserId = () => useContext(context);

interface AccountChangeProviderProps {
  children: ReactNode;
  neonUserId?: string;
}

export const NeonUserIdProvider = ({ children, neonUserId = '' }: AccountChangeProviderProps) => {
  const [userId, setUserId] = useState('');

  useEffect(() => {
    if (neonUserId) setUserId(neonUserId);
  }, [neonUserId]);

  return (
    <context.Provider
      value={{
        neonUserId: userId
      }}
    >
      {children}
    </context.Provider>
  );
};
